import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { ButtonV2 } from '@zola/zola-ui';

import './RsvpSuccessModal.less';

function RsvpSuccessModal({ onAction, pages }) {
  const isRegistryPageAvailable = _.find(pages, page => page.type === 'REGISTRY');
  return (
    <div
      className={`rsvp-success-modal ${
        isRegistryPageAvailable ? 'rsvp-success-modal--is-bigger' : ''
      }`}
    >
      <div className="rsvp-success-modal__header">
        <h1 className="rsvp-success-modal__title">Your RSVP Has Been Received!</h1>
      </div>
      <div className="rsvp-success-modal__body">
        <svg
          className="rsvp-success-modal__illustration"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 114.17 114.17"
        >
          <defs>
            <style>
              {
                '.cls-1{fill:#f6f5f0;}.cls-2{fill:#c7d6ee;}.cls-3{fill:#96b0c9;}.cls-4{fill:#003b57;}.cls-5{fill:#fff;}'
              }
            </style>
          </defs>
          <title>Your RSVP Has Been Received</title>
          <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
              <circle className="cls-1" cx="57.09" cy="57.09" r="57.09" />
              <path
                className="cls-2"
                d="M56.5,72.75h-.12L33.23,55.31h0l-9.35-7.05a1.08,1.08,0,0,0-1.06,1.08V87.88a1.08,1.08,0,0,0,1,1.07L56.36,72.79Z"
              />
              <polygon className="cls-2" points="23.9 88.97 44.2 88.97 23.9 88.96 23.9 88.97" />
              <path
                className="cls-2"
                d="M90.41,48.26,79.8,55.9v.16L57.08,72.75H57s.09,0,.13,0L90.48,89a1.08,1.08,0,0,0,1-1.07V49.34A1.08,1.08,0,0,0,90.41,48.26Z"
              />
              <polygon
                className="cls-3"
                points="79.8 51.53 79.8 55.9 90.41 48.26 90.42 48.26 79.8 40.11 79.8 51.53"
              />
              <polygon
                className="cls-3"
                points="33.23 55.31 33.23 51.53 33.23 40.69 23.87 48.26 23.88 48.26 33.23 55.31"
              />
              <path
                className="cls-4"
                d="M78.69,20.49H34.35a1.12,1.12,0,0,0-1.12,1.11V55.31h0L56.4,72.77l.1,0a.86.86,0,0,1,.45,0l.11,0L79.8,56.06V21.6A1.11,1.11,0,0,0,78.69,20.49Zm-28,12H74.77a1,1,0,0,1,0,2H50.71a1,1,0,0,1,0-2Zm0,8.2H74.77a1,1,0,0,1,0,2H50.71a1,1,0,0,1,0-2Zm-12.46-10a1,1,0,0,1,1.41.1L41.58,33l5.86-7.18A1,1,0,1,1,49,27.11l-6.62,8.11a1,1,0,0,1-.76.37h0a1,1,0,0,1-.76-.35l-2.69-3.12A1,1,0,0,1,38.25,30.71Z"
              />
              <path
                className="cls-3"
                d="M57,72.75a.86.86,0,0,0-.45,0l-.14,0L23.85,89H90.52l0,0L57.08,72.78S57,72.77,57,72.75Z"
              />
              <path
                className="cls-2"
                d="M41.6,35.59h0a1,1,0,0,0,.76-.37L49,27.11a1,1,0,1,0-1.55-1.26L41.58,33l-1.92-2.22a1,1,0,0,0-1.51,1.31l2.69,3.12A1,1,0,0,0,41.6,35.59Z"
              />
              <path className="cls-5" d="M50.71,32.52a1,1,0,0,0,0,2H74.77a1,1,0,0,0,0-2Z" />
              <path className="cls-5" d="M74.77,42.72a1,1,0,0,0,0-2H50.71a1,1,0,0,0,0,2Z" />
            </g>
          </g>
        </svg>
        <div className="rsvp-success-modal__actions">
          {isRegistryPageAvailable && (
            <ButtonV2
              onClick={() => onAction('redirect')}
              className="rsvp-success-modal__actions__button"
            >
              View Registry
            </ButtonV2>
          )}
          <ButtonV2
            onClick={() => onAction('summary')}
            className="rsvp-success-modal__actions__button"
            variant="secondary"
          >
            View RSVP Summary
          </ButtonV2>
        </div>
      </div>
    </div>
  );
}

RsvpSuccessModal.propTypes = {
  onAction: PropTypes.func,
  pages: PropTypes.arrayOf(PropTypes.shape({})),
};

export default RsvpSuccessModal;



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/pages/rsvp/RsvpSuccessModal/RsvpSuccessModal.jsx